import * as React from "react";
var BarChart = function (_a) {
    var _b = _a.width, width = _b === void 0 ? "100%" : _b;
    return (React.createElement("svg", { focusable: "false", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "currentColor", width: width },
        React.createElement("rect", { width: "4", height: "5", x: "1", y: "10", rx: "1" }),
        React.createElement("rect", { width: "4", height: "9", x: "6", y: "6", rx: "1" }),
        React.createElement("rect", { width: "4", height: "14", x: "11", y: "1", rx: "1" })));
};
export default BarChart;
